export default __webpack_public_path__ + "static/media/PERSO_5.40bf9a2f.gif";